<template>
	<div class="menus-wrap">
		<div class="relative-wrap" style="width:1000px">
		<p class="title">{{unitName}}</p>
		<el-table :data="tableData" show-summary>
			<el-table-column label="序号" width="100" align="center">
				<template v-slot="scope">
					{{ scope.$index + 1 }}
				</template>
			</el-table-column>
			<el-table-column prop="department_name" label="招聘单位"></el-table-column>
			<el-table-column prop="position_name" label="招聘岗位"></el-table-column>
			<el-table-column prop="quota" label="招聘名额"></el-table-column>
			<el-table-column prop="candidate_total" label="报考人数"></el-table-column>
			<el-table-column prop="verify_total" label="审核通过人数"></el-table-column>
			<el-table-column prop="pay_total" label="缴费人数"></el-table-column>
		</el-table>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import HeadInfo from '@/components/HeadInfo';
import store from '@/store';
import { Message } from 'element-ui';
import { reqPositionTotal } from '@/api';
export default {
	name: 'SignUp',
	components: {
		HeadInfo
	},
	data() {
		return {
			tableData: [],
			page: 1,
			limit: 10,
			total: 0,
		};
	},
	computed: {
		...mapState({
			company_id: state => state.system.company_id,
			unitName: state => state.system.unitName,
			examination_name: state => state.system.examInfo.examination_name,
		}),
	},
	created() {
		if (this.$store.state.user.total.length === 0) {
			this.getList();
		} else {
			this.tableData = this.$store.state.user.total;
		}
	},
	methods: {
		getList() {
			reqPositionTotal({
				company_id: this.company_id,
			      }).then(res => {
				this.tableData = res.data.list || [];
				this.$store.commit('user/SET_TOTAL', res.data.list || []);
			});
		},
	}
};
</script>

<style lang="scss" scoped>
.menus-wrap {
	display: flex;
	flex-direction: column;
	align-items: center;
	.el-table {
		margin-top: 50px;
	}
	.el-button {
		margin: 30px auto;
	}
	.tip {
		font-size: 24px;
		font-weight: bold;
		color: #ff070a;
		text-align: left;
	}
	
	.title {
		margin-top: 50px;
		font-size:20px;
	}
}
</style>
